import React from 'react';
import Chatbotui from '../../components/chatbotui/chatbotui';

const ChatPage = () => {
    return (
        <main>
            <Chatbotui /> 
        </main>
    );
};

export default ChatPage;
